import CtaCard from './cta-card';
export default CtaCard;